<template>
  <LoginForm></LoginForm>
</template>
<script>
import LoginForm from "../../components/Auths/Login.vue";
import { mapState } from "vuex";

export default {
  name: "Sign In View",
  components: { LoginForm },
  computed: mapState(["token"]),
  mounted() {
    if (this.token!="") {
      this.$toast.error("Already logged In");
      this.$router.push("/home");
    }
  },
};
</script>
